<template>
  <div class="row">
    <div class="col-auto min-w-250px mb-4">
      <div class="fv-row">
        <Multiselect
          ref="multiselect"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Selecione o campo à ser exibido"
          v-model="this.selectFiltro.campo"
          :searchable="true"
          :canDeselect="true"
          :options="this.camposOrdenados(this.model)"
          placeholder="Selecione um campo"
          @clear="focus"
        >
          <template v-slot:singlelabel="{ value }">
            <div class="multiselect-single-label">
              {{ value.label }}
            </div>
          </template>
          <template v-slot:option="{ option }">
            {{ option.label }}
          </template>
          <template v-slot:noresults="{}">
            <div class="m-4">
              {{ "Nenhum resultado foi encontrado" }}
            </div>
          </template>
        </Multiselect>
      </div>
    </div>
    <div v-if="this.showRemove" class="col-2 mb-4">
      <div class="fv-row">
        <button
          type="button"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Remover campo"
          class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-danger svg-icon-white px-2 pb-2"
          @click.prevent="this.$emit(`removerCampo`)"
        >
          <i class="la la-trash-o ms-1 fs-2"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <SelectQueryBuilder
        v-if="this.selectFiltro.select"
        :select="this.selectFiltro.select"
        :model="
          this.selectFiltro.tipo === 'object' &&
          this.model[this.selectFiltro.campo].items
            ? this.model[this.selectFiltro.campo].items
            : this.model[this.selectFiltro.campo]
        "
        :showRemove="false"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";

export default {
  name: "SelectQueryBuilder",
  emits: ["removerCampo"],
  components: { Multiselect },
  props: {
    select: { type: Object, required: true },
    model: { type: Object, required: true },
    showRemove: { type: Boolean, required: false, default: true },
  },
  methods: {
    focus() {
      this.$refs.multiselect.open();
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.descricao.toUpperCase();
        const descricaoB = b.descricao.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const arrayDePares = Object.entries(objeto);

      arrayDePares.sort((a, b) => compararPorDescricao(a[1], b[1]));

      const objetoOrdenado = Object.fromEntries(arrayDePares);

      const transformedJson = [];
      for (const key in objetoOrdenado) {
        transformedJson.push({
          value: key,
          label: objetoOrdenado[key].descricao,
          objeto: objetoOrdenado[key],
        });
      }

      return transformedJson;
    },
    atualizarTipo() {
      let newTipo = this.retornaTipoCampo(this.selectFiltro.campo);

      if (this.selectFiltro.tipo != newTipo) {
        if (this.selectFiltro.tipo === "object") {
          delete this.selectFiltro.select;
        }
      }

      this.selectFiltro.tipo = newTipo;
    },
    retornaTipoCampo(campo) {
      const tipo = this.model[campo]
        ? this.model[campo].tipo || "unknown"
        : "unknown";

      if (tipo === "object" || tipo === "array") {
        if (!this.selectFiltro.select) {
          this.selectFiltro.select = {
            campo: "",
            tipo: "",
          };
        }
        return "object";
      } else if (tipo.toUpperCase().includes("INT")) {
        return "number";
      } else if (tipo.toUpperCase().includes("STRING")) {
        return "text";
      } else if (tipo.toUpperCase().includes("DATETIME")) {
        return "datetime";
      } else if (tipo.toUpperCase().includes("DECIMAL")) {
        return "decimal";
      } else {
        return "text";
      }
    },
  },
  watch: {
    select: {
      handler(newRegra) {
        this.selectFiltro = this.select;
      },
      deep: true,
    },
    "select.campo": {
      handler(newRegra) {
        this.atualizarTipo();
      },
    },
    "select.tipo": {
      handler(newRegra) {
        this.atualizarTipo();
      },
    },
  },
  async mounted() {
    this.selectFiltro = this.select;
    if (this.selectFiltro.campo === "") {
      this.$refs.multiselect.open();
    }
  },
  data() {
    return {
      selectFiltro: {},
    };
  },
};
</script>

<style></style>
